<template>
  <h2 v-if="selectedAirTimeDate"
      class="bx-typo--16px bx-epg-search__date-heading">
    Das TV-Programm vom {{ selectedAirTimeDate }}
  </h2>
</template>

<script>
export default {
  props: {
    selectedAirTimeDate: {
      type: String,
      required: true
    }
  }
}
</script>
